import { calculationLimits, designFastVariables, designVehicles } from "store/calculation.config";

export const calculateLefturn = (input) => {
    const errors = {
        TOOLS_SPEEDLIMIT_TOO_LOW: false,
        TOOLS_SPEEDLIMIT_TOO_HIGH: false,
        TOOLS_LONGITUDAL_SLOPE_TOO_LOW: false,
        TOOLS_LONGITUDAL_SLOPE_TOO_HIGH: false,
        TOOLS_HOURLY_TRAFFIC_IS_EQUAL_ZERO: false,
        TOOLS_TURNING_LANE_NOT_NECESSARY: false,
        TOOLS_AADT_HEAVY_TOO_LOW: false,
        TOOLS_AADT_HEAVY_TOO_HIGH: false,
        TOOLS_TUTNING_LANE_LENGTH_CORRECTED: false,
        TOOLS_TUTNING_LANE_NOT_VALID: false,
    }

    let calculationContext = {
        normalizedInput: {...input},
        wasNormalized: false,
        errorsToSet: [],
        errorsToUnset: [],
        input:
        {
            speedlimit: {value: null, valid: null, severity: null},
            slope: {value: null, valid: null, severity: null},
            trafficThrough: {value: null, valid: null, severity: null},
            trafficTurning: {value: null, valid: null, severity: null},
            trafficOncoming: {value: null, valid: null, severity: null},
            heavyPercentage: {value: null, valid: null, severity: null},
            designVehicle: {value: null, valid: null, severity: null},
        },
        derived:
        {
            
        },
        output:
        {
            turningLaneLength: {value: null, valid: null, severity: null},
            transitionLength: {value: null, valid: null, severity: null},
            retardtionLength: {value: null, valid: null, severity: null},
            queueLength: {value: null, valid: null, severity: null},
        }
    }

    validateValues(calculationContext, errors);
    calulcateOutput(calculationContext, errors);

    calculationContext.errorsToSet = Object.keys(errors).filter(key => errors[key]);
    calculationContext.errorsToUnset = Object.keys(errors).filter(key => !errors[key]);

    return calculationContext;
}

const validateValues = (ctx, errors) => {
    // #region speedlimit
    if(ctx.normalizedInput.speedlimit.trim() !== '')
    {
        const speedlimit = Number(ctx.normalizedInput.speedlimit.trim());
        if(speedlimit < calculationLimits.minSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_LOW = true;
        }
        else if(speedlimit > calculationLimits.maxSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_HIGH = true;
        }
        else
        {
            ctx.input.speedlimit = {value: speedlimit, valid: true, severity: null};
        }
    }
    // #endregion

    // #region slope
    if(ctx.normalizedInput.slope.trim() !== '')
    {
        const slope = Number(ctx.normalizedInput.slope.trim());
        if(slope < calculationLimits.minLongitudalSlope)
        {
            ctx.input.slope = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LONGITUDAL_SLOPE_TOO_LOW = true;
        }
        else if(slope > calculationLimits.maxLongitudalSlope)
        {
            ctx.input.slope = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_LONGITUDAL_SLOPE_TOO_HIGH = true;
        }
        else
        {
            ctx.input.slope = {value: slope, valid: true, severity: null};
        }
    }
    // #endregion

    // #region traffic through
    if(ctx.normalizedInput.trafficThrough.trim() !== '')
    {
        let trafficThrough = Number(ctx.normalizedInput.trafficThrough.trim());

        if(trafficThrough < 0)
        {
            trafficThrough = Math.abs(trafficThrough);
            ctx.normalizedInput.trafficThrough = trafficThrough;
            ctx.wasNormalized = true;
        }

        if(trafficThrough === 0)
        {
            ctx.input.trafficThrough = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_HOURLY_TRAFFIC_IS_EQUAL_ZERO = true;
        }
        else
        {
            ctx.input.trafficThrough = {value: trafficThrough, valid: true, severity: null};
        }
    }
    // #endregion

    // #region traffic turning
    if(ctx.normalizedInput.trafficTurning.trim() !== '')
    {
        let trafficTurning = Number(ctx.normalizedInput.trafficTurning.trim());

        if(trafficTurning < 0)
        {
            trafficTurning = Math.abs(trafficTurning);
            ctx.normalizedInput.trafficTurning = trafficTurning;
            ctx.wasNormalized = true;
        }

        if(trafficTurning === 0)
        {
            ctx.input.trafficTurning = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_HOURLY_TRAFFIC_IS_EQUAL_ZERO = true;
        }
        else
        {
            ctx.input.trafficTurning = {value: trafficTurning, valid: true, severity: null};
        }
    }
    // #endregion

    // #region traffic oncoming
    if(ctx.normalizedInput.trafficOncoming.trim() !== '')
    {
        let trafficOncoming = Number(ctx.normalizedInput.trafficOncoming.trim());

        if(trafficOncoming < 0)
        {
            trafficOncoming = Math.abs(trafficOncoming);
            ctx.normalizedInput.trafficOncoming = trafficOncoming;
            ctx.wasNormalized = true;
        }

        if(trafficOncoming === 0)
        {
            ctx.input.trafficOncoming = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_HOURLY_TRAFFIC_IS_EQUAL_ZERO = true;
        }
        else
        {
            ctx.input.trafficOncoming = {value: trafficOncoming, valid: true, severity: null};
        }
    }
    // #endregion

    // #region heavy percentage
    if(ctx.normalizedInput.heavyPercentage.trim() !== '')
    {
        const heavyPercentage = Number(ctx.normalizedInput.heavyPercentage.trim());
        if(heavyPercentage < 0)
        {
            ctx.input.heavyPercentage = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_AADT_HEAVY_TOO_LOW = true;
        }
        else if(heavyPercentage > 100)
        {
            ctx.input.heavyPercentage = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_AADT_HEAVY_TOO_HIGH = true;
        }
        else
        {
            ctx.input.heavyPercentage = {value: heavyPercentage, valid: true, severity: null};
        }
    }
    // #endregion

    // #region design vehicle
    if(ctx.normalizedInput.designVehicle.trim() !== '')
    {
        let designVehicleObject = designVehicles[ctx.normalizedInput.designVehicle];
        if(designVehicleObject) ctx.input.designVehicle = {value: designVehicleObject, valid: true, severity: null};
        else ctx.input.designVehicle = {value: null, valid: false, severity: 'error'};
    }
    // #endregion
}

const calulcateOutput = (ctx, errors) => {
    // #region calculating recomendation
    if(ctx.input.speedlimit.valid && ctx.input.trafficThrough.valid && ctx.input.trafficTurning.valid && ctx.input.trafficOncoming.valid)
    {
        if(
            (
                ctx.input.trafficOncoming.value + ctx.input.trafficThrough.value < 150
            ) ||
            (
                ctx.input.trafficOncoming.value + ctx.input.trafficThrough.value >= 150 &&
                ctx.input.trafficOncoming.value + ctx.input.trafficThrough.value < 400 &&
                ctx.input.speedlimit.value <= 60 &&
                ctx.input.trafficTurning.value < (150 - 0.2 * (ctx.input.trafficOncoming.value + ctx.input.trafficThrough.value))
            ) ||
            (
                ctx.input.trafficOncoming.value + ctx.input.trafficThrough.value >= 150 &&
                ctx.input.trafficOncoming.value + ctx.input.trafficThrough.value < 400 &&
                ctx.input.speedlimit.value > 60 &&
                ctx.input.trafficTurning.value < (82 - 0.08 * (ctx.input.trafficOncoming.value + ctx.input.trafficThrough.value))
            ) ||
            (
                ctx.input.trafficOncoming.value + ctx.input.trafficThrough.value >= 400 &&
                ctx.input.trafficOncoming.value + ctx.input.trafficThrough.value < 900 &&
                ctx.input.trafficTurning.value < 20
            )
        ) errors.TOOLS_TURNING_LANE_NOT_NECESSARY = true;
    }
    // #endregion

    // #region queue length
    if(ctx.input.speedlimit.valid &&
        ctx.input.trafficThrough.valid &&
        ctx.input.trafficTurning.valid &&
        ctx.input.trafficOncoming.valid &&
        ctx.input.slope.valid &&
        ctx.input.heavyPercentage.valid &&
        ctx.input.designVehicle.valid
    )
    {
        const criticalGapBasicValue = 5;
        const criticalFollowUpTimeBasicValue = 3;
        const vehicleLength = designFastVariables.vehicleLength;
        const heavyVehicleLength = designFastVariables.heavyVehicleLength;

        const criticalGap = criticalGapBasicValue + 0.04 * (ctx.input.speedlimit.value - 50);
        const followUpTime = Math.abs(criticalGap * criticalFollowUpTimeBasicValue/criticalGapBasicValue);

        const basicCapacity = (ctx.input.trafficOncoming.value * Math.exp(-ctx.input.trafficOncoming.value * criticalGap / 3600))/(1 - Math.exp(-ctx.input.trafficOncoming.value * followUpTime/3600));
        const basicCapacityCorrected = basicCapacity * (1.1 - ctx.input.heavyPercentage.value/100) * (1 - 7 * ctx.input.slope.value);
        const capacityReserve = basicCapacityCorrected - ctx.input.trafficTurning.value;
        //const loadLevel = ctx.input.trafficTurning.value/capacityReserve;

        const meanDelay = (3600/capacityReserve) - 2;
        const totalDelay = meanDelay * ctx.input.trafficTurning.value / 3600;

        const vehicleAmount = totalDelay < 1 ? 1 + 3.3 * totalDelay : 4.3 + 3 * totalDelay;

        const queueLength = vehicleAmount * (vehicleLength * (1 - (ctx.input.heavyPercentage.value/100)) + heavyVehicleLength * (ctx.input.heavyPercentage.value/100));

        console.log(ctx.input.designVehicle.value);
        if(ctx.input.designVehicle.value.length && queueLength < (ctx.input.designVehicle.value.length + 1))
        {
            ctx.output.queueLength = {
                value: (ctx.input.designVehicle.value.length + 1),
                valid: true,
                severity: null
            }
        }
        else
        {
            ctx.output.queueLength = {
                value: Math.round(queueLength),
                valid: true,
                severity: null
            }
        }
        
    }
    // #endregion

    // #region
    if(ctx.input.speedlimit.valid && ctx.input.slope.valid)
    {
        ctx.output.retardtionLength = {
            value: Math.round(((ctx.input.speedlimit.value * 0.7)**2)/(76.28256 + 254.2752 * ctx.input.slope.value)),
            valid: true,
            severity: null
        }
    }
    // #endregion

    // #region transition length
    if(ctx.input.speedlimit.valid)
    {
        ctx.output.transitionLength = {
            value: ctx.input.speedlimit.value > 65 ? 25 : 15,
            valid: true,
            severity: null
        }
    }
    // #endregion

    // #region turning lane length
    if(ctx.output.queueLength.valid && ctx.output.retardtionLength.valid && ctx.output.transitionLength.valid)
    {
        const turningLaneLength = ctx.output.queueLength.value + ctx.output.retardtionLength.value - ctx.output.transitionLength.value;

        if(turningLaneLength < 0 || turningLaneLength > 150)
        {
            errors.TOOLS_TUTNING_LANE_NOT_VALID = true;
            ctx.output.queueLength = {
                value: null,
                valid: false,
                severity: null
            }

            ctx.output.transitionLength = {
                value: null,
                valid: false,
                severity: null
            }

            ctx.output.retardtionLength = {
                value: null,
                valid: false,
                severity: null
            }
        }
        else
        {
            ctx.output.turningLaneLength = {
                value: Math.round(turningLaneLength),
                valid: true,
                severity: null
            }
        }
    }
    
    // #endregion
}